import React from 'react';
import styles from './hera-page-features.module.css';
import {
  ContainerFluid,
  Htag,
  HtagAlign,
  HtagVariant,
  ListCardDescription,
} from '../../components';

import user from '../../public/hera/description/user.png';
import admin from '../../public/hera/description/admin.png';
import challenge from '../../public/hera/description/challenge.png';

const descriptions = [
  {
    src: user,
    alt: 'user',
    title: 'User roles',
    text: 'While the app development, our team was working on 3 user flows: pregnant woman, mom of the newborn and woman that faced pregnancy loss.',
    id: '1',
  },
  {
    src: admin,
    alt: 'admin',
    title: 'Admin panel ',
    text: 'The app mostly consists of the content that is uploaded via admin panel: recipes, workouts and yoga videos, healthcare tips, articles and images.',
    id: '2',
  },
  {
    src: challenge,
    alt: 'challenges',
    title: 'Challenges',
    list: [
      '3D baby model',
      'custom built admin panel',
      'custom character painted in 82 illustrations',
    ],
    id: '3',
  },
];

export default function HeraPageFeatures() {
  return (
    <section className={styles.features}>
      <ContainerFluid>
        <div className={styles.features_inner}>
          <Htag
            tag="h3"
            className={styles.features_title}
            align={HtagAlign.center}
            variant={HtagVariant.h3}
          >
            CORE FEATURES
          </Htag>
          <ListCardDescription cards={descriptions} />
        </div>
      </ContainerFluid>
    </section>
  );
}
